import { Checkbox, FormControlLabel } from "@material-ui/core";

const SmileCheckbox = ({value, text, onChange}) => {
  const linkRegex = /\[([^\]]+)\]\(([^)]+)\)/g;

  const parts = [];
  let lastIndex = 0;

  for (const match of text.matchAll(linkRegex)) {
    const matchText = match[0];
    const linkText = match[1];
    const linkHref = match[2];
    const start = match.index;

    // Texto antes del link
    if (lastIndex < start) {
      parts.push(text.slice(lastIndex, start));
    }

    // El link
    parts.push(
      <a
        key={parts.length}
        href={linkHref}
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-600 underline"
      >
        {linkText}
      </a>
    );

    lastIndex = start + matchText.length;
  }

  // Texto que queda después del último link
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return <FormControlLabel required control={<Checkbox checked={value}  onChange={onChange}/>} label={parts}/>;
}
 
export default SmileCheckbox;